
export const DehlarDashboardPermissions = {
  DehlarDashboardPermissions: 
  {
    permissionsId: "b20db2a8-f41f-4e53-a928-4db72f4ae624",
    permissionsName: "Dehlar Dashboard Permissions",
    description: null,
    componentsId: null,
    components: null
   }  
  } ;
  